import {
  emitWebVitalIfValueChanged,
  emitWebVitalOnce,
  finalizeView,
  isViewEndEvent,
  shouldIgnoreViewUpdate,
} from './datadog-rum-web-vital-dedup'
import { TELEMETRY_EVENT_NAMES } from './telemetry-events.constants'
import { trackInternalEvent } from './track'

import type { RumBeforeSend, RumViewEvent } from '@datadog/browser-rum'

const NS_PER_MS = 1_000_000

/**
 * Forward Datadog RUM web vitals from view events into Internal Analytics.
 */
export const datadogRumBeforeSend: RumBeforeSend = (event, _context) => {
  if (event.type !== 'view') {
    return true
  }

  trackWebVitalsFromViewEvent(event)
  return true
}

function trackWebVitalsFromViewEvent(event: RumViewEvent) {
  const viewId = event.view.id
  if (!viewId || shouldIgnoreViewUpdate(viewId)) {
    return
  }

  const { performance } = event.view

  const fcp = performance?.fcp?.timestamp
  if (fcp != null) {
    // eslint-disable-next-line i18next/no-literal-string
    emitWebVitalOnce(viewId, 'fcp', () => {
      trackInternalEvent(TELEMETRY_EVENT_NAMES.FCP_EVENT, { fcp: Math.round(fcp / NS_PER_MS) })
    })
  }

  const lcp = performance?.lcp?.timestamp
  if (lcp != null) {
    // eslint-disable-next-line i18next/no-literal-string
    emitWebVitalOnce(viewId, 'lcp', () => {
      trackInternalEvent(TELEMETRY_EVENT_NAMES.LCP_EVENT, { lcp: Math.round(lcp / NS_PER_MS) })
    })
  }

  const cls = performance?.cls?.score
  if (cls != null) {
    // eslint-disable-next-line i18next/no-literal-string
    emitWebVitalIfValueChanged(viewId, 'cls', cls, () => {
      trackInternalEvent(TELEMETRY_EVENT_NAMES.CLS_EVENT, { cls })
    })
  }

  const inp = performance?.inp?.duration
  if (inp != null) {
    const inpMs = Math.round(inp / NS_PER_MS)
    // eslint-disable-next-line i18next/no-literal-string
    emitWebVitalIfValueChanged(viewId, 'inp', inpMs, () => {
      trackInternalEvent(TELEMETRY_EVENT_NAMES.INP_EVENT, { inp: inpMs })
    })
  }

  const ttfb = event.view.first_byte
  if (ttfb != null) {
    // eslint-disable-next-line i18next/no-literal-string
    emitWebVitalOnce(viewId, 'ttfb', () => {
      trackInternalEvent(TELEMETRY_EVENT_NAMES.TTFB_EVENT, { ttfb: Math.round(ttfb / NS_PER_MS) })
    })
  }

  if (isViewEndEvent(event)) {
    finalizeView(viewId)
  }
}
